// ── API Enum Values ──
// These match the backend API contract exactly (camelCase strings).

export enum PersonType {
  Employee = 'employee',
  Visitor = 'visitor',
  Contractor = 'contractor',
  Unlisted = 'unlisted',
  Tenant = 'tenant',
}

export enum PersonStatusEnum {
  NotChecked = 0,
  Accounted = 1,
  NotAccounted = 2,
}

export enum IncidentType {
  Drill = 'drill',
  Fire = 'fire',
  Weather = 'weather',
  Medical = 'medical',
  Security = 'security',
  Hazmat = 'hazmat',
}

export enum IncidentStatus {
  Active = 'active',
  Closed = 'closed',
}
